module.exports = __webpack_public_path__ + "static/media/db_arrow_left.8b262504.svg";